import { useEffect } from 'react'
import { TextCentered } from 'shared/components/Base/TextFormat'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { NAV_LEFT_WRAP } from 'shared/components/Nav/NavLeft'
import { Handler } from 'shared/helpers/typeHelper'
import { muiTheme } from 'shared/theme'
import { bgGray, paleyellow } from 'shared/theme/colors'
import { styled, ThemeProvider } from 'styled-components'

interface AppLayoutProps {
  children: React.ReactNode
  navBar?: React.ReactNode
  onClose: Handler
}

export const APP_LAYOUT_CLASS_NAME = 'app-layout'

export function AppLayout({ children, navBar, onClose }: AppLayoutProps) {
  useEffect(() => {
    document.body.classList.add(APP_LAYOUT_CLASS_NAME)

    return () => {
      document.body.classList.remove(APP_LAYOUT_CLASS_NAME)
    }
  }, [])

  return (
    <ThemeProvider theme={muiTheme}>
      <Wrap>
        <Box mt={6} />
        {navBar && (
          <NavBar>
            <TextCentered>{navBar}</TextCentered>
            <Close>
              <Button onClick={onClose} variant="secondary" size="small">
                Go Back
              </Button>
            </Close>
          </NavBar>
        )}
        <Left id={NAV_LEFT_WRAP}></Left>
        <Box mt={12} />
        {children}
        <style>
          {`
        .profile-page-switch,
        main > div:first-child,
        header > div:first-child > button:first-child,
        header [aria-label="Refresh"] {
          display: none;
        }


        #main-content {
          margin: 0;
          padding: 0;
        }

        header {
          transform: translateY(0) !important;
          visibility: visible !important;
        }
      `}
        </style>
        <Box mt={4} />
      </Wrap>
    </ThemeProvider>
  )
}

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${bgGray};
`

const NavBar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 48px;
  height: 33px;
  background-color: ${paleyellow};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

const Close = styled.div`
  position: absolute;
  right: 24px;
`

const Left = styled.div`
  position: absolute;
  left: 24px;
`
